import PropTypes from "prop-types"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import styles from "../../../styles/Login.module.css"

export default function SmsVerificationScreen({
  resolver,
  verificationSMSCode,
  onVerificationSMSCodeChange,
  onResolveSMS,
  isResending,
  autoSmsNeedsManualRequest,
  loading,
  verificationId,
  recaptchaVerifier,
  recaptchaReady,
  onResend,
  onBack,
}) {

  const phoneLastDigits = () => {
    const phoneResolver = resolver.hints.find(({ factorId }) => factorId === "phone")
    return phoneResolver.phoneNumber.slice(-4)
  }

  return (
    <>
      <h2>Two-Factor Verification</h2>
      <p className={styles.subhead}>
        Enter the verification code sent to your phone ending in {phoneLastDigits()}.
      </p>

      <div className="form-section">
        <div className="form-field">
          <label htmlFor="smsCode">Verification Code</label>
          <InputText
            id="smsCode"
            name="smsCode"
            value={verificationSMSCode}
            onChange={({ target: { value } }) => onVerificationSMSCodeChange(value)}
            disabled={loading}
          />
        </div>
        <Button
          type="button"
          className={`btn ${styles.actionBtn}`}
          label={loading ? "Verifying code..." : "Verify Code"}
          onClick={onResolveSMS}
          loading={loading}
          disabled={loading || !verificationSMSCode || isResending || !verificationId}
        />
        {!recaptchaVerifier && (
          <small className={styles.warnText}>
            SMS verification is unavailable because security verification could
            not be initialized.
          </small>
        )}
        {recaptchaVerifier && !recaptchaReady && (
          <small className={styles.warnText}>
            Preparing security verification. Please wait...
          </small>
        )}
        {autoSmsNeedsManualRequest && !verificationId && (
          <small className={`${styles.warnText} ${styles.warnBlock}`}>
            Automatic code request failed. Please click Resend Code to request
            your verification code.
          </small>
        )}
        <p className={styles.resendRow}>
          Didn't receive a code?{" "}
          <button
            type="button"
            onClick={onResend}
            disabled={loading || isResending || !recaptchaVerifier || !recaptchaReady}
            className={styles.resendLink}
          >
            {isResending ? "Resending..." : "Resend Code"}
          </button>
        </p>
      </div>
      <button
        className={`${styles["plain-text-link"]} ${styles.backLink}`}
        onClick={onBack}
        type="button"
        disabled={loading}
      >
        Back to Login
      </button>
    </>
  )
}

SmsVerificationScreen.propTypes = {
  resolver: PropTypes.object,
  verificationSMSCode: PropTypes.string.isRequired,
  onVerificationSMSCodeChange: PropTypes.func.isRequired,
  onResolveSMS: PropTypes.func.isRequired,
  isResending: PropTypes.bool.isRequired,
  autoSmsNeedsManualRequest: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  verificationId: PropTypes.string,
  recaptchaVerifier: PropTypes.object,
  recaptchaReady: PropTypes.bool,
  onResend: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}
